import { OrderItem } from "./types";
import * as React from "react";

export const renderOrderItems = (items: OrderItem[]) => {
 return <div>
     {
       items.map((item: OrderItem) => {
         return (
           <div>
             <strong>Property Id: {item.PropertyID}</strong><br/>
             Name: {item.PropertyName}<br/>
             Amount: {item.Amount}<br/>
             Token price: {item.TokenPrice} USD<br/>
             Price: {item.Price} USD<br/>
           </div>
         )
       })
     }
 </div>
}
